import { render, staticRenderFns } from "./SiteService.vue?vue&type=template&id=24dbf2ec&scoped=true"
import script from "./SiteService.vue?vue&type=script&lang=js"
export * from "./SiteService.vue?vue&type=script&lang=js"
import style0 from "./SiteService.vue?vue&type=style&index=0&id=24dbf2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dbf2ec",
  null
  
)

export default component.exports